import { SelectElementProps } from "react-hook-form-mui";
import { SelectBase } from "./components";
import { Asset } from "../Asset";
import { Box, Chip } from "@mui/material";

interface Props extends Omit<SelectElementProps, 'options'> {
    options: Array<{id: any, label: string}>
}

export function Select(props: Props){
    return (
        <SelectBase
            SelectProps={{
                IconComponent: ({className}) => (
                    <Asset
                        imgProps={{
                            className,
                            style: {
                                top: 'calc(50% - 0.75em)'
                            }
                        }}
                        h={24} 
                        w={24} 
                        namespace="icons" 
                        filename="dropdown.svg"
                    />
                ),
                renderValue: (value: unknown) => (
                    <Chip 
                        key={value as string}
                        sx={{
                            color: '#5a677d',
                            height: '24px'
                        }} 
                        label={
                            props.options
                                .find(({id}) => id === value)
                                ?.label
                        } 
                    />
                )
            }}
            {...props}
        />
    )
}